var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('div',{staticClass:"text-center loader d-flex justify-center",class:(_vm.fullScreen) ? 'full-screen' : 'inside-parent'},[_c('div',{staticClass:"spinner-border",class:_vm.previewLoader ? 'preview-loader' : '',attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00897255","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Loader.vue
// module id = Av+Y
// module chunks = 82 101 102